module.exports = __webpack_public_path__ + "static/media/mzd.19ddf374.jpg";